<template>
    <div class="float-links">
        <ul data-spm="fx">
            <li class="back-top">
                <a href="javascript:void(0)" @click="goRefresh">
                    <img class="fb-icon" src="../images/icon_refresh.png"/>
                </a>
            </li>
            <li class="back-sohu prize-survey" data-role="on_back">
                <a href="http://www.sohu.com?strategyid=24" target="_blank">
                    <img class="fb-icon" src="//statics.itc.cn/mptc-mpfe/img/components-pc/logo_sohu.png"/>
                    <div class="tooltip">
                        <div class="side-sohu-tooltip">返回首页</div>
                        <div class="side-sohu-three"></div>
                    </div>
                </a>
            </li>
            <li id="feedBackBtn" class="user-feedback">
                <FeedBackBtn/>
            </li>
            <li class="back-top" data-role="go_top">
                <transition name="fade">
                    <a href="javascript:void(0)" @click="goTop"  v-show="showBackUp">
                        <img class="fb-icon" src="//statics.itc.cn/mptc-mpfe/img/components-pc/icon_Up.png"/>
                    </a>
                </transition>
            </li>
        </ul>
    </div>
</template>
<script>
import FeedBackBtn from '../vuecomps/feedBackBtn.vue'
import Util from "../_utils/util"

export default {
    components: {
        FeedBackBtn
    },
    data() {
        return {
            showBackUp: false
        }
    },
    mounted() {
        window?.sohuSpm?.domDidChange({ target: 'fx' });   
        window.addEventListener(
                "scroll",
                Util.throttle(() => {
                    var disTop =
                        document.documentElement.scrollTop ||
                        window.pageYOffset ||
                        document.body.scrollTop // 页面滚动距离
                    var windowHeight = window.innerHeight
                    if(disTop>windowHeight*1/2) {
                        this.showBackUp = true
                        window?.sohuSpm?.domDidChange({ target: 'fx' });   
                    }else {
                        this.showBackUp = false
                    }
                }, 500)
            )
    },
    methods: {
        goTop() {
            window?.sohuSpm?.sendAction({ acode:8104 });
            window.scrollTo(0, 0);
        },
        // 刷新
        goRefresh() {
            location.reload();
        }
    }
}
</script>
<style lang="less" scoped>
.float-links{
    width:48px;
    position:fixed;
    bottom:100px;
    left:50%;
    margin-left:600px;
    li{
        width:100%;
        height:48px;
        margin-top:8px;
        background:#F2F2F2;
        font-size:14px;
        line-height:16px;
        text-align:center;
        a{
            width:100%;
            height:100%;
            display:flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .tooltip{
                display: none;
                .side-sohu-tooltip {
                    position: absolute;
                    right: 58px;
                    top: 10px;
                    width: 78px;
                    height: 32px;
                    background: #333333;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
                .side-sohu-three {
                    border-bottom: 8px solid transparent;
                    border-left: 4px solid #333;
                    border-top: 8px solid transparent;
                    height: 0;
                    position: absolute;
                    right: 54px;
                    top: 18px;
                    width: 0;
                }
            }
        }
        .icon{
            width:18px;
            height:18px;
            margin:0 auto;
        }
        .fb-icon{
            width: 18px;
            height: 18px;
        }
        &:hover{
            background:#EBEBEB;
        }
    }
    .back-sohu>a:hover {
        .tooltip {
            display: block;
        }
    }
    .user-feedback>a:hover {
        .tooltip {
            display: block;
        }
    }
    .back-top{
        background:inherit;
        a {
            background:#F2F2F2;
            &:hover{
                background:#EBEBEB;
            }
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .fb-icon{
            width: 18px;
            height: 18px;
        }
        &:hover{
            background:inherit;
        }
        .fade-enter,.fade-leave-to {
            opacity: 0;
        }
        .fade-enter-active,
        .fade-leave-active {
            transition: all .5s;
        }
    }
     .prize-survey{
        background:#FFD100;
    }
     .prize-survey:hover{
        background:#FFE561;
    }
    .prize-survey:active{
        background:#F79D00;
    }
    //  .prize-survey a, .prize-survey a:hover{
    //     color:#333;
    // }
}
</style>